<div class="pageHeader" role="heading" style="display:flex; flex-direction:row; flex-wrap: wrap; width:100%;">
    <!-- Left -->
    <div *ngIf="showStudent">
        <table>
            <tr>
                <td>
                    <img *ngIf="selectedStudent && selectedStudent.Picture != null" (contextmenu)="onRightClick($event)"
                        (click)="studentImageClicked(selectedStudent.Picture)"
                        src="data:image/jpg;base64,{{selectedStudent.Picture}}" style="z-index:9999999; height:85px;">
                    <img *ngIf="selectedStudent && selectedStudent.Picture == null" src="./assets/images/nopicture.jpg"
                        style="z-index:9999999; height:85px;">
                </td>
                <td>
                    <div style="height:85px; padding-left: 5px; margin-bottom: 5px; position: relative;">
                        <h3 [hidden]="userType != 3 && !disableNavigation" class="sis-app-header-label ng-binding"
                            style="padding-left: 10px" *ngIf="!useStudentName && selectedStudent != undefined">
                            <span>{{selectedStudent.FirstName}} {{selectedStudent.LastName}}</span>
                            <span>{{getStudentSuffix()}}</span>
                        </h3>

                        <h3 [hidden]="userType != 3 && !disableNavigation" class="sis-app-header-label ng-binding"
                            style="padding-left: 10px" *ngIf="useStudentName">
                            <span>{{useStudentName}}</span>
                        </h3>

                        <studentSelection *ngIf="students && !disableNavigation" [hidden]="userType == 3"
                            [students]="students" [forStudentSearch]="true" [overrideStudent]="useStudents != null"
                            [selectedStudent]="selectedStudent" [showEnrollmentDates]="showEnrollmentDates"
                            (studentChanged)="studentId = $event">
                        </studentSelection>

                        <div *ngIf="!V10 && studentEnrollment"
                            [ngStyle]="{'color':studentEnrollment.EnrollmentStatus==2 ? 'rgb(166,166,166)' : ''}"
                            style="margin-top:5px;padding-left:10px;">
                            <span *ngIf="userType == 1"
                                style="padding-left:10px;">#{{selectedStudent.StudentNumber}}&nbsp;</span>
                            <span translate>Grade</span>
                            {{studentEnrollment.GradeLevel}} - {{studentEnrollment.SchoolName}} - {{studentEnrollment.Calendar}}
                            <span *ngIf="studentEnrollment.EnrollmentStatus==2"
                                style="background-color: rgb(153,153,153); color: black;"> <span translate>Withdrawn as of</span>&nbsp;
                                {{studentEnrollment.WithdrawalDate | date:'MM/dd/yy'}}</span>
                            <span *ngIf="studentEnrollment.EnrollmentStatus==0"
                                style="background-color: #8bc34a; color: black;" translate> Projected</span>
                        </div>

                        <div *ngIf="V10 && studentEnrollment" style="margin-top:5px;padding-left:10px;">
                            <span *ngIf="userType == 1"
                                style="padding-left:10px;">#{{selectedStudent.StudentNumber}}&nbsp;</span>
                            <span translate>Grade</span>
                            {{studentEnrollment.GradeLevel}} - {{studentEnrollment.SchoolName}}
                            <span *ngIf="studentEnrollment.NoShow" translate> - No Show</span>
                        </div>

                        <div *ngIf="studentEnrollment == null" style="margin-top: 5px;padding-left:10px;" translate>
                            {{noEnrollmentString}}
                        </div>

                        <div style="display: flex; flex-direction: row; padding-top: 2px;">
                            <div style="padding-left: 10px;" *ngIf="showDetailsButton && hasPermission">
                                <button color="primary" style="margin-left: 5px; line-height: 28px;" mat-stroked-button (click)="viewStudentDetails()">
                                    <span translate>Details</span>
                                </button>
                            </div>
                            <div style="padding-left: 10px;" *ngIf="showReEnrollButton">
                                <button style="width: inherit; text-align: center; background: #3f51b5; color: white; line-height: 32px;"
                                    mat-button (click)="reEnrollStudentClick()"><span translate>Re-Enroll Students</span></button>
                            </div>
                            <div>                                
                                <student-alerts style="display:flex; position:absolute; bottom:0px; padding-left:10px"
                                    *ngIf="showAlerts && studentAlerts" [alerts]="studentAlerts" [alertHeight]="24"
                                    [distanceBetween]="8" [collapsed]="true" [showAllAlerts]="true"></student-alerts>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
        </table>
    </div>

    <!-- Middle -->
    <div>
        <ng-content></ng-content>
    </div>

    <!-- Right -->
    <div>
        <div style="display: flex; justify-content: flex-end;">
            <div *ngIf="stepNumber != null" class="step">{{stepNumber}}</div>
            <h3 class="sis-app-header-label" style="text-align:right;" translate>{{pageTitle}}</h3>
        </div>
        <div style="margin-top:5px; margin-bottom: 5px; text-align:right;"
            *ngIf="!courseRequestYear && showYearSelector && !useParentPortalYear && !showAYLabel">
            <span translate>Academic Year</span> -
            <tyl-form-field style="width:170px; padding-left:5px;">
                <mat-select id="selectedYearDropdown"
                    [ngModel]="useYear ? useYear.Id : (selectedYear ? selectedYear.Id : -1)"
                    (ngModelChange)="yearChanged($event)" [disabled]="disableYearSelect">
                    <mat-option *ngFor="let year of years"
                        [disabled]="onlineRegistration ? !year.OnlineRegistration : (parentPortalUpdate ? !year.OpenForRegistration : (V10 == false ? (eForm ? !year.EformYearEnabled : year.Disabled) : false))"
                        [value]="year.Id">
                        {{year.Description}}
                    </mat-option>
                </mat-select>
            </tyl-form-field>
        </div>
        <!--Default Enrollment Year Selector-->
        <div style="margin-top:5px; margin-bottom: 5px; text-align:right;"
            *ngIf="!courseRequestYear && showYearSelector && useParentPortalYear && !showAYLabel">
            <span translate>Academic Year</span> -
            <tyl-form-field style="width:170px; padding-left:5px;">
                <mat-select id="defaultYearDropdown"
                    [ngModel]="defaultYear ? defaultYear.Id : (defaultYear ? defaultYear.Id : -1)"
                    (ngModelChange)="yearChanged($event)" [disabled]="disableYearSelect">
                    <mat-option
                        [disabled]="onlineRegistration ? !defaultYear.OnlineRegistration : (parentPortalUpdate ? !defaultYear.OpenForRegistration : (V10 == false ? defaultYear.Disabled:false))"
                        [value]="defaultYear.Id">
                        {{defaultYear.Description}}
                    </mat-option>
                </mat-select>
            </tyl-form-field>
        </div>
        <div style="margin-top:5px;margin-bottom:5px;text-align:right;" *ngIf="courseRequestYear">
            <span *ngIf="courseRequestYear.Status == 1">
                <span translate>Academic Year</span> - {{ courseRequestYear.Description}}
            </span>
            <span *ngIf="courseRequestYear.Status != 1" style="padding-left:5px; padding-right:5px; margin-right:-5px;"
                [ngStyle]="{'background-color':courseRequestYear.Status==0 ? '#ff4081' : '#00e676'}">
                <span translate>Academic Year</span> - {{ courseRequestYear.Description }}
            </span>
        </div>
        <div style="margin-top:5px;margin-bottom:5px;text-align:right;"
            *ngIf="showAYLabel && (useYear || selectedYear)">
            <span translate>Academic Year</span> - {{ useYear ? useYear.Description : selectedYear.Description}}
        </div>
        <table>
            <tr>
                <!-- <td style="padding-right: 10px;">
                    <div style="margin-top:15px; text-align:right;"
                        *ngIf="!V10 && showCustomLayouts && pageTitle == 'Academic History'">
                        <tyl-form-field label="Layout Type">
                            <mat-select id='ddlTypeView' [(ngModel)]='selectedViewTypeId'
                                (selectionChange)="selectedViewTypeChange()">
                                <mat-option *ngFor='let layout of ViewlayoutTypes' [value]='layout.Id'>
                                    {{layout.Name.replace("Academic History","")}}</mat-option>
                            </mat-select>
                        </tyl-form-field>
                    </div>
                </td> -->
                <td *ngIf="showCustomLayouts">
                    <div style="margin-top:15px; text-align:right;">
                        <tyl-form-field label="Layout">
                            <mat-select id='ddlLayout' [(ngModel)]='selectedLayoutId'
                                (selectionChange)="selectedLayoutChange()">
                                <mat-option *ngFor='let layout of customLayouts' [value]='layout.Id'>
                                    {{layout.Name}}
                                </mat-option>
                            </mat-select>
                        </tyl-form-field>
                    </div>
                    <div *ngIf="!V10 && selectedLayoutTypeName.length > 0" [ngStyle]="{'top': instanceName && instanceName.length > 0 ? '160px' : '140px'}"
                        style="position:absolute; right:17px;">
                        Type: {{selectedLayoutTypeName}}
                    </div>
                </td>
            </tr>
        </table>
    </div>
</div>